/* @jsx h */
import { defineComponent, h } from "vue";
import { PageComponent, useLocalization } from "@lemmonhq/uikit";
import { useGroupAuth } from "@app/vue/providers/GroupAuth";

// Settings shell for Group (Admin) mode. Hosts the settings subpages
// (base settings, users) as tabs and renders the active one via its RouterView.
export const GroupSettingsPage = defineComponent({
  name: "GroupSettingsPage",
  setup() {
    const { t } = useLocalization();
    const auth = useGroupAuth();

    return () => (
      <PageComponent
        title={t("admin.common.settings")}
        titleIcon="settings"
        subpages={[
          {
            name: t("admin.common.settings"),
            icon: "tune",
            href: "/group/settings",
          },
          ...(auth.isGroupAdmin.value
            ? [
                {
                  name: t("admin.common.users"),
                  icon: "group",
                  href: "/group/settings/users",
                },
                {
                  name: t("settings.assets.page_title"),
                  icon: "perm_media",
                  href: "/group/settings/assets",
                },
              ]
            : []),
        ]}
      />
    );
  },
});
